import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function imageSelection(state = initialState.imageSelection, action) {
  switch (action.type) {
    case types.INITIATE_IMAGE_SELECTION:
      return {
        ...state,
        isArchiving: false,
        archiveResponse: {},
        error: null,
      };
    case types.INITIATE_IMAGE_ARCHIVAL:
      return {
        ...state,
        isArchiving: true,
        archiveResponse: {},
        error: null,
      };
    case types.IMAGE_ARCHIVE_SUCCESS:
      return {
        ...state,
        isArchiving: false,
        archiveResponse: action.archiveResponse,
      };
    case types.IMAGE_ARCHIVE_FAILURE:
      return {
        ...state,
        isArchiving: false,
        error: action.error,
      };
    default:
      return state;
  }
}
